module.exports = __webpack_public_path__ + "static/media/phone-book.0acfc820.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/OrganizationalUnit/phone-book.svg
// module id = 2417
// module chunks = 0